"use client";

import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNotifications } from "../../../../hooks/useNotifications";

const NotificationsDropdown = () => {
  //const { data } = useNotifications({ status: "UNREAD", limit: 5 });
  const { data } = useNotifications({ unread: true, limit: 5 });

  return (
    <Dropdown className="dropdown notifications noti">
      <Dropdown.Toggle className="border-0 p-0 position-relative">
        <i className="material-symbols-outlined">notifications</i>
        {data.length > 0 && <span className="badge-dot"></span>}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-lg dropdown-menu-end p-0">
        <div className="title px-3 py-2">
          اعلان‌ها ({data.length})
        </div>

        <div className="max-h-217 scrollbar">
          {data.map((item) => (
            <Link
              key={item.id}
              to="/notifications"
              className="dropdown-item unseen"
            >
              <p className="mb-0">{item.title}</p>
              <span className="fs-12 text-muted">
                {new Date(item.createdAt).toLocaleString("fa-IR")}
              </span>
            </Link>
          ))}
        </div>

        <Link
          to="/notifications"
          className="dropdown-item text-center text-primary fw-medium"
        >
          دیدن همه اعلان‌ها
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default NotificationsDropdown;
